import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect } from 'react-router-dom'
import Modal from 'react-modal'
import gameActions from '../../store/actions/gameActions'
import NarrativeEndScreen from './NarrativeEndScreen'
import Scene from './scenes/Scene'
import Minigame from './Minigame'
import Choices from "./Choices"
import Loading from '../Loading'
import AnimationLayout from '../AnimationLayout'
import Button from '../Button'

const NarrativeScreen = () => {
    const [state, setState] = useState({
        open: false,
        tags: null
    })

    const { open, tags } = state

    const dispatch = useDispatch()
    const gameState = useSelector(state => state.game)
    const { narrative, isLoading, ending, sceneText, currentTags, globals, currentChoices, isInMinigame, currentMinigame, choicesMade } = gameState

    useEffect(() => {
        console.log(currentTags)
        if (currentTags?.item) {
            console.log(currentTags?.item)
            if (currentTags?.item2) {
                dispatch(gameActions.checkItem([currentTags.item, currentTags.item2], narrative))
            } else {
                console.log('object')
                dispatch(gameActions.checkItem(currentTags.item, narrative))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentTags])

    const getHelpModalContent = (tags) => {
        let text, help

        if (tags?.minigame) {
            switch (tags.minigame) {
                case 'photo':
                    text = 'Este é um momento de narrativa de minijogo, mais especificamente um minijogo de foto. O objetivo deste minijogo consiste em tirar uma fotografia da imagem que se encontra presente, sendo que esta foto será guardada na caderneta de viagens da Matilde. Para tal só necessita de carregar na imagem.'
                    help = 'Carregue na imagem para tirar uma fotografia e depois carregue no botão Avançar.'
                    break;
                case 'puzzle':
                    text = 'Este é um momento de narrativa de minijogo, mais especificamente um minijogo de puzzle. O objetivo deste minijogo consiste ordernar corretamente as peças da imagem. Para tal só necessita de carregar nas diferentes porções da imagem arrastá-las para os locais corretos das mesmas. O jogo termina quando todas as porções das imagens ficam corretamente ordernadas.'
                    help = 'Ordene todas as peças do puzzle corretamente e depois carregue no botão Avançar.'
                    break;
                case 'wordSearch':
                    text = 'Este é um momento de narrativa de minijogo, mais especificamente um minijogo de sopa de letras. O objetivo deste minijogo consiste em advinhar e contruir todas as palavras que são sugeridas pelas dicas. Para formar a palavra é preciso carregar nos diferentes botões que contêm letras de forma a criar palavras. Quando todas as palavras forem descobertas e escritas o jogo acaba, podendo carregar no botão de Avançar para prosseguir a narrativa.'
                    help = 'Descobra todas as palavras segundo as pistas dadas e forme as mesmas carregando nos botões que contêm diferentes letras, e, depois de descobrir todas as palavras carregue no botão de Avançar.'
                    break;
                case 'quizz':
                    text = 'Este é um momento de narrativa de minijogo, mais especificamente um minijogo de quizz. O objetivo deste minijogo consiste responder corretamente uma série de perguntas escolhendo a resposta certa para cada pergunta. Quando terminarem todas as perguntas, independentemente de ter respondido tudo bem ou mal, o jogo acaba. Depois pode simplesmente carregar no botão de avançar para continuar com a narrativa.'
                    help = 'Responda a todas as perguntas colocadas carregando nos botões que contêm respostas e, depois das perguntas terminarem carregue no botão Avançar.'
                    break;
                default:
                    return null
            }
        } else {
            let item
            let choiceKind

            if (tags?.news) {
                item = 'uma notícia real sobre uma situação/tema que foi referida durante a narrativa'
            } else if (tags?.info) {
                item = 'um pequeno texto informativo de um facto/curiosidade que surgiu durante a narrativa'
            } else if (tags?.graph) {
                item = 'o gráfico que ilustra os dados referidos no texto descritivo'
            } else if (tags?.map) {
                item = 'o mapa que representa certas localizações'
            } else {
                item = 'a imagem presente'
            }

            if (currentChoices.length > 1) {
                choiceKind = 'no botão de uma das escolhas presentes'
            } else {
                choiceKind = 'botão de Avançar'
            }

            text = `Esta é um momento de narrativa normal, onde a história progride de forma linear, sendo a única ação possível realizar ler o texto corrido e observar ${item}, bem como a expressão facial da Matilde. Posto isto, para avançar a história é só necessário ${choiceKind}.`
            help = `Para avançar necessita só de carregar ${choiceKind}.`
        }

        return (
            <div>
                <p className='pb-2'>{text}</p>
                <p className='pb-2 font-bold'>{help}</p>
            </div>
        )
    }

    return (
        isLoading ? <Loading /> :
            ending ? <NarrativeEndScreen choices={choicesMade} /> :
                ending && gameState.chapter === 'cutscene-inicial' ? <Redirect to='/dashboard' /> :
                    <AnimationLayout>
                        <div className='grid grid-cols-1 gap-4 mb-8'>
                            <div className='white-container md:col-span-4'>
                                {currentTags?.item ? <Loading /> :
                                    <>
                                        {gameState.chapter !== 'cutscene-inicial' &&
                                            <section id='narrativeInfo'>
                                                <div className='grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 flex items-center'>
                                                    <div className="lg:col-span-6 flex flex-row justify-between lg:justify-start pl-0">
                                                        <div className='mr-8'>
                                                            <img className='object-contain md:pb-5' style={{ maxHeight: 125, maxWidth: 125 }}
                                                                alt={currentTags.matildeMood} src={require(`../../assets/img/matilde-faces/${currentTags.matildeMood}`)}
                                                            />
                                                        </div>
                                                        <div className='w-full md:pb-2 mr-6'>
                                                            <h6 className='mb-0 pb-1'>Tempo</h6>
                                                            <p>{globals[0].day} - {globals[1].hours}</p>
                                                        </div>
                                                        <div className='w-full md:pb-2'>
                                                            <h6 className='mb-0 pb-1'>Localização</h6>
                                                            <p>{globals[2].location}</p>
                                                        </div>
                                                    </div>

                                                </div>
                                                <hr className='mb-6' />
                                            </section>
                                        }

                                        <section id='narrativeBody'>
                                            {(sceneText[0] !== "") ?
                                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8 lg:gap-12 mb-10">
                                                    {sceneText &&
                                                        <div className='py-5 lg:py-8'>
                                                            {sceneText.map((text, idx) => <p className='mb-2 flex-wrap' key={idx}>{text}</p>)}
                                                        </div>
                                                    }
                                                    <div className='py-5 lg:py-8'>
                                                        {currentTags && <Scene tags={currentTags} />}
                                                        {isInMinigame && currentMinigame !== 'photo' && <Minigame tags={currentTags} />}
                                                    </div>
                                                </div>
                                                :
                                                <div className="grid grid-cols-1 gap-4 sm:gap-6 md:gap-8 lg:gap-12 mb-10">
                                                    <div className='m-auto'>
                                                        {currentTags && <Scene tags={currentTags} />}
                                                        {isInMinigame && currentMinigame !== 'photo' && <Minigame tags={currentTags} />}
                                                    </div>
                                                </div>
                                            }

                                            <hr className='mb-6' />
                                        </section>

                                        <div className='flex flex-wrap justify-between items-center'>
                                            <div>
                                                <Button className='my-2' onClick={() => setState({ tags: currentTags, open: !open })}>Ajuda</Button>
                                                {gameState.chapter !== 'cutscene-inicial' &&
                                                    <Button onClick={() => setState({ ...state, open: !open })}>Abandonar Narrativa</Button>
                                                }
                                            </div>
                                            {currentChoices && <Choices choices={currentChoices} minigame={isInMinigame} />}
                                        </div>

                                    </>
                                }
                            </div>
                        </div>
                        {open && tags &&
                            <Modal
                                isOpen={open}
                                contentLabel="Modal de item individual"
                                className='modal'
                                ariaHideApp={false}
                                closeTimeoutMS={300}
                                shouldCloseOnOverlayClick={true}
                            >
                                <div className='modal-guts'>
                                    <div className='flex flex-wrap justify-between items-center'>
                                        <h2>Caixa de ajudas da Matilde</h2>
                                    </div>
                                    <div className='grid grid-cols-1'>
                                        {getHelpModalContent(tags)}
                                    </div>
                                    <div className='pt-5 flex justify-end'>
                                        <Button
                                            className='mr-0'
                                            onClick={() => setState({ open: !open, tags: null })}
                                        >
                                            Fechar
                                    </Button>
                                    </div>
                                </div>
                            </Modal>
                        }

                        {open && !tags &&
                            <Modal
                                isOpen={open}
                                contentLabel="Modal de confimação"
                                className='modal'
                                ariaHideApp={false}
                                closeTimeoutMS={200}
                                shouldCloseOnOverlayClick={true}
                                onAfterClose={() => setState({ ...state, open: !open })}
                                onRequestClose={() => setState({ ...state, open: !open })}
                            >
                                <div className='modal-guts'>
                                    <h3 className='p-0'>Pretende mesmo desistir da narrativa?</h3>
                                    <p className='py-6'>Se estiver a ter dificuldades utilize o botão de ajuda para perceber melhor o que necessita fazer para avançar.</p>
                                    <div className='flex justify-end flex-wrap w-full'>
                                        <Button onClick={() => setState({ ...state, open: !open })}>Voltar</Button>
                                        <Button
                                            className='mr-0'
                                            onClick={() => {
                                                setState({ ...state, open: !open })
                                                dispatch(gameActions.quitGame())
                                            }}
                                        >
                                            Desistir
                                    </Button>
                                    </div>
                                </div>
                            </Modal>
                        }
                    </AnimationLayout>
    )
}

export default NarrativeScreen